import React from 'react'
import { useSelector } from 'react-redux'
import {
  selectStepCreateBanner,
  selectLastCreatedBanner,
} from 'routing/fetchingfunction/user/user.reducer'

const Head = () => {
  const step = useSelector(selectStepCreateBanner)
  const lastBanner = useSelector(selectLastCreatedBanner)

  return (
    <>
      <div className=" text-center">
        {step === 1 ? (
          <>
            <h3 className="text-[30px] font-semibold mb-6">Setup Your Class Banner</h3>

            <p> The information below is visible to all students.</p>
            <p>You can change it from the settings panel at anytime.</p>
          </>
        ) : (
          `Availability for ${lastBanner?.class_banner_category?.name} Class (${step}/2)`
        )}

        {/* <p className="text-center">
        {step === 1
          ? 'The information below is visible for all students. You can change it from the settings panel anytime.'
          : 'You can change it from the settings panel at anytime.'}
      </p> */}
      </div>
    </>
  )
}
export default React.memo(Head)
